/**
 *
 * jQuery Dropdown Plugin
 */

'use strict';
import $ from 'jquery';

$.fn.dropdown = function () {
    let $menuItem = $('nav > ul > li.nav__item.-arrow');

    $menuItem.each(function () {
        const $parent = $(this);
        const $dropdown = $parent.find('.dropdown');
        const $trigger = $parent.find('[data-toggle="dropdown"]');

        const children = $dropdown[0].querySelectorAll('.nav__link');
        const FOCUSABLE_CHILDREN = [...Array.from(children), $trigger[0]];
        let isExpanded = false;

        function openDropdown() {
            $dropdown.addClass('open').attr('aria-expanded', 'true');
            isExpanded = true;
            $('body').on('focusin', function () {
                childHasFocus();
            });
        }

        function closeDropdown() {
            $dropdown.removeClass('open').attr('aria-expanded', 'false');
            isExpanded = false;
            $('body').off('focusin');
        }

        function toggleDropdown() {
            if (isExpanded) {
                closeDropdown();
            } else {
                openDropdown();
            }
        }

        // Close dropdown it the user tabs outside of it.
        function childHasFocus() {
            let hasActive = FOCUSABLE_CHILDREN.includes(document.activeElement);
            if (!hasActive) {
                closeDropdown();
            }
        }

        $parent
            .on('mouseenter', function () {
                openDropdown();
            })
            .on('mouseleave', function () {
                closeDropdown();
            });

        $trigger.on('click', function () {
            toggleDropdown();
        });
    });
};
